package com.cybersoftsolution.cybersoftsolutionweb.components.sections


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.ContentLayout
import com.cybersoftsolution.cybersoftsolutionweb.components.text.WritableSpanText
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.receiveAsFlow
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.w3c.dom.Element

@Composable
fun ContactSection(
    pageSection: PageSection,
    sectionModifier: Modifier = Modifier,
    contentModifier: Modifier = Modifier,
    title: String? = null,
) {
    val accentShadow = Modifier
        .border {
            color(Theme.HalfBlack.rgb)
            width(1.px)
        }
        .boxShadow(
            offsetX = 0.px,
            offsetY = 0.px,
            blurRadius = 8.px,
            spreadRadius = 4.px,
            color = Theme.Primary.rgb
        )
    val noShadow = Modifier
        .boxShadow(
            offsetX = 0.px,
            offsetY = 0.px,
            blurRadius = 8.px,
            spreadRadius = 4.px,
            color = Theme.Transparent.rgb
        )

    var showFullText by remember { mutableStateOf(false) }
    var showButton by remember { mutableStateOf(false) }

    var switchShadowStyle by remember { mutableStateOf(false) }
    var stopShadowStyle by remember { mutableStateOf(false) }
    var shadowStyle by remember { mutableStateOf(noShadow) }


    LaunchedEffect(switchShadowStyle,stopShadowStyle) {
        if (stopShadowStyle){
            shadowStyle = noShadow
            switchShadowStyle = false
            return@LaunchedEffect
        }
        delay(2000)
        shadowStyle = if (switchShadowStyle) {accentShadow} else {noShadow}
        switchShadowStyle = !switchShadowStyle
    }

    LaunchedEffect(Unit) {
        switchShadowStyle = !switchShadowStyle
    }


    ContentLayout(
        title = title,
        pageSection = pageSection,
        sectionModifier = sectionModifier,
        contentModifier = contentModifier.then(Modifier.transition(Transition.of(property = TransitionProperty.All, duration = 500.ms)))
    ){

        Image(
            modifier = Scale_Selected_ItemStyle.toModifier()
                then(shadowStyle)
                .id("skillsImageId")
                .cursor(Cursor.Pointer)
                .transition(Transition.of(property = TransitionProperty.All, duration = 1000.ms))
                .onClick {
                    showFullText = true
                    stopShadowStyle = true
                }
                .aspectRatio(1)
                .fillMaxWidth(100.px)
                .borderRadius(50.px)


            ,
            src = Resources.Images.skills,
            alt = "CEO En proceso de desarrollo",
        )



        WritableSpanText(
            id = "TextoConEfectoEscrituraId",
            modifier = Modifier
                .margin(topBottom = 10.px)
                .color(Theme.HalfBlack.rgb)
                .fontStyle(FontStyle.Italic),
            runEffect = showFullText,
            fullText = "“ Ya sea que estés buscando aumentar tu " +
                    "presencia en línea, optimizar tus procesos " +
                    "internos o lanzar un nuevo producto, podemos" +
                    " ayudarte. Nuestro enfoque se basa en la " +
                    "innovación, la calidad y la atención al cliente. " +
                    "Contáctanos hoy mismo para discutir tus proyectos " +
                    "y descubrir cómo podemos ayudarte a alcanzar tus" +
                    " objetivos ”",
            onCompleteEffect = {
                showButton = true
            }

        )


        MyButton(
            width = if (showButton) null else 0.px,

            modifier = Modifier
                .visibility(if (showButton) Visibility.Visible else Visibility.Hidden)
                .height((0).px)
                .thenIf(
                    condition = showButton,
                    other = Modifier.height((54).px)
                )
                .thenIf(
                    condition = showButton,
                    other = Modifier.fillMaxWidth()
                )
                .transition(Transition.of(property = TransitionProperty.All, duration = 750.ms))
                ,
            id = "contentButtonId",
            buttonType = MyButtonType.Primary,
            text = if (showButton) "Contactanos y obtén un estimado gratis" else null,
            onClick = {

            },
            enabled = showButton,
            fontSize = 18
        )

    }


}





object ElementoVisibilidadObservador {
    private val visibilidadCambioChannel = Channel<Pair<String, Boolean>>(Channel.BUFFERED)
    val visibilidadCambioFlow = visibilidadCambioChannel.receiveAsFlow()

    private val observadores = mutableMapOf<String, IntersectionObserver>()

    fun observarElemento(id: String) {
        if (observadores.containsKey(id)) return

        val elemento = document.getElementById(id) as? Element ?: return

        val observer = IntersectionObserver { entries, observerInstance ->
            entries.forEach { entry ->
                val isIntersecting = js("entry.isIntersecting") as Unit
                if (jsTypeOf(isIntersecting) == "boolean" && isIntersecting as Boolean) {
                    visibilidadCambioChannel.trySend(Pair(id, true))
                } else {
                    visibilidadCambioChannel.trySend(Pair(id, false))
                }
            }
            if (entries.isEmpty()){
                visibilidadCambioChannel.trySend(Pair(id, false))
            }
        }

        observer.observe(elemento)
        observadores[id] = observer
    }

    fun dejarDeObservarElemento(id: String) {
        observadores.remove(id)?.disconnect()
    }
}
